"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BeforeLate = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const BeforeLate = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      transform: "translate(-6.5 -1.416)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
        x2: "15",
        transform: "translate(7 1.916)",
        strokeLinecap: "square"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
        x2: "15",
        transform: "translate(7 20.916)",
        strokeLinecap: "square"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M10,20.916V17.658a3.439,3.439,0,0,1,.578-1.907l2.862-4.293L10.578,7.165A3.439,3.439,0,0,1,10,5.258V2",
        transform: "translate(-1.71 0)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M33.439,2V5.258a3.439,3.439,0,0,1-.578,1.907L30,11.458l2.862,4.293a3.439,3.439,0,0,1,.578,1.908v3.258",
        transform: "translate(-13.112 0)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M17,32.512v-.248a.43.43,0,0,1,.073-.239l2.937-4.4,2.937,4.405a.432.432,0,0,1,.072.239v.248Z",
        transform: "translate(-5.701 -14.606)",
        strokeLinecap: "square"
      })]
    })
  });
};
exports.BeforeLate = BeforeLate;